/**
 * Controller for [data-secondary-panel] — unlike other .dom.js files in this folder (whose
 * elements always exist and are just shown/hidden), this one creates the element itself, and
 * only when the caller actually asks for it: floorPlanDetail.plugin.js only calls this factory
 * on desktop (see its start()), so the node never exists in the DOM at all on mobile.
 *
 * @module nativeInteractiveSiteMap/components/secondaryPanelController.dom
 */
import renderFloorPlanCarousel, { initializeFloorPlanCarousel } from './floorPlanCarousel.dom';

const ROOT_CLASS = 'nhs-u-absolute--cover nhs-u-background-color--white-100 nhs-u-z-index--content-secondary';

/**
 * @param {HTMLElement} containerElement - appended into immediately; the map's own sized,
 *   positioned container, so this panel's absolute positioning resolves against it.
 * @returns {{ show: Function, hide: Function, remove: Function }}
 */
export default function createSecondaryPanelController(containerElement) {
  const element = document.createElement('div');
  element.className = ROOT_CLASS;
  element.hidden = true;
  element.setAttribute('data-secondary-panel', '');
  element.setAttribute('data-qa', 'native_ism_secondary_panel');
  containerElement.appendChild(element);

  return {
    /**
     * @param {object} params
     * @param {object[]} [params.floorplans] - The selected plan's `floorplans` array, unsorted.
     */
    show({ floorplans }) {
      element.innerHTML = renderFloorPlanCarousel({ floorplans });
      element.hidden = false;
      initializeFloorPlanCarousel();
    },

    hide() {
      element.hidden = true;
    },

    remove() {
      element.remove();
    },
  };
}
